import { v4 as uuidv4 } from 'uuid';

const ALERTS_SHOW = 'ALERTS_SHOW';
const ALERTS_HIDE = 'ALERTS_HIDE';
const ALERTS_HIDE_ALL = 'ALERTS_HIDE_ALL';

export const addAlerte = (alerte) => (dispatch) => {
    dispatch({
        type: ALERTS_SHOW,
        alerte,
    });
};

export const hideAlerte = (id) => (dispatch) => {
    dispatch({
        type: ALERTS_HIDE,
        id,
    });
};

export const hideAllNotification = () => (dispatch) => {
    dispatch({ type: ALERTS_HIDE_ALL });
};

export const AlertesReducer = (state = [], action = {}) => {
    switch (action.type) {
        case ALERTS_SHOW:
            return [
                ...state,
                {
                    id: uuidv4(),
                    ...action.alerte,
                },
            ];
        case ALERTS_HIDE:
            return state.filter((alerte) => {
                return alerte.id !== action.id;
            });
        case ALERTS_HIDE_ALL:
            return [];
        default:
            return state;
    }
};
